
export type Option = {
  label: string;
  value: number;
};

export type GuideOption = {
  label: string;
  value: string;
};

export const startDelayOptions: Option[] = [
  {
    label: 'No delay',
    value: 0,
  },
  {
    label: '5 seconds',
    value: 5,
  },
  {
    label: '10 seconds',
    value: 10,
  },
  {
    label: '15 seconds',
    value: 15,
  },
  {
    label: '30 seconds',
    value: 30,
  },
];

export enum GuideValues {
  Off = 'off',
  Top = 'top',
  Center = 'center',
  Bottom = 'bottom',
}

export const guideOptions: GuideOption[] = [
  {
    label: 'Off',
    value: GuideValues.Off,
  },
  {
    label: 'Top',
    value: GuideValues.Top,
  },
  {
    label: 'Center',
    value: GuideValues.Center,
  },
  {
    label: 'Bottom',
    value: GuideValues.Bottom,
  },
];

export enum StudioViewPositions {
  TELEPROMPTER = 'TELEPROMPTER',
  CAMERA = 'CAMERA',
}

export enum StudioMode {
  TELEPROMPTER = 'TELEPROMPTER',
  CAMERA = 'CAMERA',
}

export const studioViewPosition = [
  {
    label: 'Teleprompter',
    value: StudioViewPositions.TELEPROMPTER,
  },
  {
    label: 'Camera',
    value: StudioViewPositions.CAMERA,
  },
];
